import React, { useEffect, useState } from "react";
import * as Styles from "../Farmers/components/FarmerForm/style";
import close from "../assets/images/close.png";
import * as Yup from "yup";
import { Formik } from "formik";
import { InputGroup } from "../shared/InputGroup/InputGroup2";
import { SelectGroup } from "../shared/SelectGroup/SelectGroup";
import { toast } from "react-toastify";
import { MultiSelect } from "react-multi-select-component";
import Cookies from 'universal-cookie'
import axios from "axios";

const cookies = new Cookies()
const gatewayInitialValues = {
  gateway_id: "",
  solarAttached: 'yes',
  gsmSimNumber: "",
  internetActive: 'yes',
  gpsAttached: 'yes',
  devBoard: "",
  latitude: 0,
  longitude: 0,
  communicationProtocol: ["bluetooth"],
  macAddress: "",
  batteryLevel: 0,
  firmwareVersion: "",
  installationDate: "",
  last_seen: new Date().toISOString(),
  status: "active",
};

const gatewaySchema = Yup.object().shape({
  gateway_id: Yup.string().required("Gateway ID is required"),
  solarAttached: Yup.string().required("Solar attached status is required"),
  gsmSimNumber: Yup.string()
    .required("GSM SIM number is required")
    .matches(/^[+]?[0-9]{10,15}$/, "Mobile number is not valid"),
  internetActive: Yup.string().required("Internet active status is required"),
  gpsAttached: Yup.string().required("GPS attached status is required"),
  devBoard: Yup.string().required("Dev board is required"),
  latitude: Yup.number().required("Latitude is required").min(-90).max(90),
  longitude: Yup.number().required("Longitude is required").min(-180).max(180),
  macAddress: Yup.string().required("MAC address is required"),
  batteryLevel: Yup.number()
    .required("Battery level is required")
    .min(0)
    .max(100),
  firmwareVersion: Yup.string().required("Firmware version is required"),
  installationDate: Yup.date().required("Installation date is required"),
  last_seen: Yup.date().required("Last seen date is required"),
  status: Yup.string()
    .oneOf(["active", "inactive"], "Invalid status")
    .required("Status is required"),
});

const communicationProtocol = [
  { value: "bluetooth", label: "Bluetooth" },
  { value: "wifi", label: "Wifi" },
  { value: "GSM", label: "GSM" },
];
const metrics = [
  "temperature",
  "pressure",
  "humidity",
  "co2_gas",
  "audio",
  "image",
  "video",
];
const boardNames = ["esp32_nodemcu", "raspberry_pi_zero_2_w"];
const status = ["active", "inactive"];
const sensorCommunicationProtocols = ["i2s", "spi"];
const yesOrNo = ["yes", "no"];

export const AddGatewayForm = (props) => {
  const { handleClose } = props;
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [inHiveSensor, setInHiveSensor] = useState([]);
  const [type, settype] = useState("create");
  const [formdata, setformdata] = useState(gatewayInitialValues);

  const getInHiveSensor = async () => {
    try {
      const currentToken = cookies.get("access_token");

      const headers = {
        headers: {
          authorization: `Bearer ${currentToken}`,
        },
      };
      const res = await axios.get(
        `${process.env.REACT_APP_HUMBLEBEE_API_URL}/sensors/get-all-sensors`,
        headers
      );
      if (res.data) {
        const data = res.data.map((it) => ({
          value: it.hive_id,
          label: it.hive_id,
        }));
        setInHiveSensor(data);
      }
    } catch (error) {
      console.log(error);
      toast.error("Error in getting inhive sensors data");
    }
  };

  useEffect(() => {
    getInHiveSensor();
  }, []);

  const [selectedCommunicationProtocol, setSelectedCommunicationProtocol] = useState([
    { value: "bluetooth", label: "Bluetooth" },
  ]);
  const [selectedSensorsConnected, setSelectedSensorsConnected] = useState([]);

  const handleSubmit = async (values, { resetForm }) => {
    console.log('submit');
    if (selectedCommunicationProtocol.length === 0) {
      toast.error('Please select at least one Communication Protocol');
      return;
    }
    if(selectedSensorsConnected.length==0){
      toast.error('Please select at least one InHive Sensor connected');
      return;
    }

    try {
      setIsSubmitting(true);

      const payload = {
        gateway_id: values.gateway_id,
        solar_attached: values.solarAttached === 'yes',
        gsm_sim_number: values.gsmSimNumber,
        internet_active: values.internetActive === 'yes',
        gps_attached: values.gpsAttached === 'yes',
        dev_board: values.devBoard,
        latitude: values.latitude,
        longitude: values.longitude,
        communication_protocol: selectedCommunicationProtocol.map(item => item.value),
        mac_address: values.macAddress,
        battery_level: values.batteryLevel,
        firmware_version: values.firmwareVersion,
        installation_date: values.installationDate,
        last_seen: new Date().toISOString(),
        status: values.status,
        sensors_connected: selectedSensorsConnected.map(item => item.value)
      };

        console.log("Payload being sent:", payload);
        const currentToken = cookies.get('access_token')

        const  headers= {
          authorization: `Bearer ${currentToken}`,
          'Content-Type': 'application/json',
      }
        const response = await fetch(`${process.env.REACT_APP_HUMBLEBEE_API_URL}/sensors/register/gateway`, {
          method: 'POST',
          headers: headers,
          body: JSON.stringify(payload),
        });

      if (!response.ok) {
        const errorData = await response.json();
        console.error('Error response:', errorData);
        throw new Error(errorData.message || 'Gateway submission failed');
      }

      const result = await response.json();
      console.log('Success:', result);
      toast.success('Gateway submitted successfully');
      resetForm();
      setSelectedCommunicationProtocol([{ value: "bluetooth", label: "Bluetooth" }]);
      setSelectedSensorsConnected([]);
      handleClose();
    } catch (error) {
      console.error('Error:', error);
      toast.error(error.message || 'Error: Gateway not submitted');
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    console.log(props.type,props.intialData);
    if (props.type === "edit" && props.intialData) {
      const initialData = props.intialData;
  
      const formattedData = {
        gateway_id:initialData.gateway_id||'',
        devBoard: initialData.dev_board || "",
        ideoStreamEnabled: initialData.video_stream_enabled ? "yes" : "no",
        captureIntervalSeconds: initialData.capture_interval_seconds || 0,
        gsmSimNumber: initialData.gsm_sim_number || "",
        macAddress: initialData.mac_address || "",
        solarAttached: initialData.solar_attached ? "yes" : "no",
        batteryLevel: initialData.battery_level || 0,
        firmwareVersion: initialData.firmware_version || "",
        installationDate: initialData.installation_date || "",
        status: initialData.status || "active",
        internetActive:initialData.internet_active? "yes" : "no",
        gpsAttached: initialData.gps_attached? "yes" : "no",
        last_seen:initialData.last_seen,
        latitude: initialData.latitude||0,
        longitude: initialData.longitude||0,
            };
      console.log(initialData.communication_protocol);
      // Setting values that match handleSubmit's expected format
      setSelectedCommunicationProtocol(
        initialData.communication_protocol?.map((it) => ({
          value: it,
          label: it,
        })) || []
      )
      setSelectedSensorsConnected(
        initialData.sensors_connected?.map((it) => ({
          value: it,
          label: it,
        })) || []
      )
      console.log(formattedData);
      setformdata(formattedData);
      settype(props.type);
    }
  }, [])
  

  const handleClose2 = () => {
    handleClose();
  };

  return (
    <Styles.ModalContent>
      {/* Added onSubmit to Formik */}
      <Formik
        initialValues={formdata}
        onSubmit={handleSubmit}
        validationSchema={gatewaySchema}
        validateOnMount
        enableReinitialize={true}
      >
        {/* Added Formik props and error handling  */}
        {({ handleSubmit, handleChange, values, errors, touched }) => (
          <Styles.FormWithCloseButton onSubmit={handleSubmit}>
            <Styles.CloseButtonDiv>
              {console.log(errors,values,touched)}
              <h3>{type=='edit'?'Edit':'Add'} Gateway</h3>
              <Styles.FormCloseButton2 onClick={handleClose2}>
                <img src={close} alt="Close" />
              </Styles.FormCloseButton2>
            </Styles.CloseButtonDiv>
            <Styles.MainFarmerFormDiv>
              <Styles.RowFlex>
                <InputGroup
                  PlaceholderText="Enter Gateway ID"
                  LabelText="Gateway ID"
                  name="gateway_id"
                  type="text"
                  value={values.gateway_id }
                  star="*"
                  onChange={handleChange}
                  error={touched.gateway_id && errors.gateway_id}
                />
                <InputGroup
                  PlaceholderText="Enter Dev Board"
                  LabelText="Dev Board"
                  name="devBoard"
                  type="text"
                  star="*"
                  value={values.devBoard }

                  onChange={handleChange}
                  error={touched.devBoard && errors.devBoard}
                />
              </Styles.RowFlex>

              <Styles.RowFlex>
                <SelectGroup
                  PlaceholderText="Is Solar Attached"
                  LabelText="Solar Attached"
                  name="solarAttached"
                  value={values.solarAttached }

                  onChange={handleChange}
                  options={yesOrNo}
                  star="*"
                  error={touched.solarAttached && errors.solarAttached}
                />
                <SelectGroup
                  PlaceholderText="Is Internet Active"
                  LabelText="Internet Active"
                  name="internetActive"
                  value={values.internetActive }

                  onChange={handleChange}
                  options={yesOrNo}
                  star="*"
                  error={touched.internetActive && errors.internetActive}
                />
              </Styles.RowFlex>

              <Styles.RowFlex>
                <SelectGroup
                  PlaceholderText="Is GPS Attached"
                  LabelText="GPS Attached"
                  value={values.gpsAttached }

                  name="gpsAttached"
                  onChange={handleChange}
                  options={yesOrNo}
                  star="*"
                  error={touched.gpsAttached && errors.gpsAttached}
                />
                <SelectGroup
                  PlaceholderText="Enter Status"
                  LabelText="Status"
                  value={values.status }

                  name="status"
                  onChange={handleChange}
                  options={status}
                  star="*"
                  error={touched.status && errors.status}
                />
              </Styles.RowFlex>

              <Styles.RowFlex>
                <InputGroup
                  PlaceholderText="Enter GSM SIM Number"
                  LabelText="GSM SIM Number"
                  name="gsmSimNumber"
                  value={values.gsmSimNumber }

                  type="text"
                  star="*"
                  onChange={handleChange}
                  error={touched.gsmSimNumber && errors.gsmSimNumber}
                />
             
                <InputGroup
                  PlaceholderText="Enter Last Seen"
                  LabelText="Last Seen"
                  value={values.last_seen ? new Date(values.last_seen).toISOString().split("T")[0] : ""}

                  name="last_seen"
                  type="date"
                  star="*"
                  onChange={handleChange}
                  error={touched.last_seen && errors.last_seen}
                />
              </Styles.RowFlex>

              <Styles.RowFlex>
                <InputGroup
                  PlaceholderText="Enter Latitude"
                  LabelText="Latitude"
                  name="latitude"
                  type="number"
                  value={values.latitude }

                  star="*"
                  onChange={handleChange}
                  error={touched.latitude && errors.latitude}
                />
                <InputGroup
                  PlaceholderText="Enter Longitude"
                  LabelText="Longitude"
                  value={values.longitude }

                  name="longitude"
                  type="number"
                  star="*"
                  onChange={handleChange}
                  error={touched.longitude && errors.longitude}
                />
              </Styles.RowFlex>

              <Styles.RowFlex>
                <InputGroup
                  PlaceholderText="Enter MAC Address"
                  LabelText="MAC Address"
                  name="macAddress"
                  value={values.macAddress }

                  type="text"
                  star="*"
                  onChange={handleChange}
                  error={touched.macAddress && errors.macAddress}
                />
                <InputGroup
                  PlaceholderText="Enter Battery Level"
                  LabelText="Battery Level"
                  name="batteryLevel"
                  value={values.batteryLevel }

                  type="number"
                  star="*"
                  onChange={handleChange}
                  error={touched.batteryLevel && errors.batteryLevel}
                />
              </Styles.RowFlex>

              <Styles.RowFlex>
                <InputGroup
                  PlaceholderText="Enter Firmware Version"
                  LabelText="Firmware Version"
                  name="firmwareVersion"
                  type="text"
                  star="*"
                  value={values.firmwareVersion }
                  onChange={handleChange}
                  error={touched.firmwareVersion && errors.firmwareVersion}
                />
                <InputGroup
                  PlaceholderText="Enter Installation Date"
                  LabelText="Installation Date"
                  name="installationDate"
                  type="date"
                  star="*"
                  value={values.installationDate ? new Date(values.installationDate).toISOString().split("T")[0] : ""}
                  onChange={handleChange}
                  error={touched.installationDate && errors.installationDate}
                />
              </Styles.RowFlex>


              <div className="multi-select-group" style={{ marginBottom: "20px", marginTop: "20px" }}>
                <label>Select Sensors</label>
                <MultiSelect
                  options={inHiveSensor}
                  value={selectedSensorsConnected}
                  onChange={setSelectedSensorsConnected}
                  labelledBy="Select Sensors Connected *"
                  hasSelectAll={false}
                />
              </div>

              <div className="multi-select-group" style={{ marginBottom: "20px", marginTop: "20px" }}>
                <label>Select Communication Protocol</label>
                <MultiSelect
                  options={communicationProtocol}
                  value={selectedCommunicationProtocol}
                  onChange={setSelectedCommunicationProtocol}
                  labelledBy="Select Communication Protocol*"
                  hasSelectAll={false}
                />
              </div>
            </Styles.MainFarmerFormDiv>

            <Styles.CreateFarmerButton type="submit" disabled={isSubmitting}>
              {isSubmitting ? "Submitting..." : type=='edit'? 'Update'  : "Create"}
            </Styles.CreateFarmerButton>
          </Styles.FormWithCloseButton>
        )}
      </Formik>
    </Styles.ModalContent>
  );
}